import {incomePlanAxios} from '../../axios';

//Ghost data for rendering default adjustment form.
const ADJUSTMENT_DEFAULT = [
    {
        description: 'Education Expense',
        value: null,
        start_year: null,
        end_year: null,
        direction: '0',
        key: 0  //For vue to uniquely track these defaults in an array since they don't have id;
    },
    {
        description: 'Health Insurance',
        value: null,
        start_year: null,
        end_year: null,
        direction: '0',
        key: -1
    },
    {
        description: 'Travel Budget',
        value: null,
        start_year: null,
        end_year: null,
        direction: '0',
        key: -2
    }
]

//Income Needs
const INCOME_NEEDS_VARIABLES_INITIALIZED = 'INCOME_NEEDS_VARIABLES_INITIALIZED';
const INCOME_NEEDS_UPDATED = 'INCOME_NEEDS_UPDATED';
const INCOME_NEEDS_ADJUSTMENT_CREATED = 'INCOME_NEEDS_ADJUSTMENT_CREATED';
const INCOME_NEEDS_ADJUSTMENT_DELETED = 'INCOME_NEEDS_ADJUSTMENT_DELETED';
const INCOME_NEEDS_ADJUSTMENT_UPDATED = 'INCOME_NEEDS_ADJUSTMENT_UPDATED';
const INCOME_NEEDS_ADJUSTMENT_DEFAULT_CREATED = 'INCOME_NEEDS_ADJUSTMENT_DEFAULT_CREATED';
const INFLATION_RATE_INITIALIZED = 'INFLATION_RATE_INITIALIZED';


export const incomePlanner = {

    namespaced: true,

    state: {
        sipsTable: {
            sipsTable: {}
        },
        riskMeter: {},
        successMeter: {},
        yearsPeopleDie: [],
        showBenchMark: false,
        incomeNeeds: {
            monthlyIncomeNeeds: null,
            relativePlanYears: {},
            adjustments: ADJUSTMENT_DEFAULT
        },
        inflation: 0.00
    },

    getters: {
        relativeYearMonthlyIncome() {
            return this.sipsTable.relativeYearMonthlyIncome;
        },

        relativeYearMonthlyNeeds() {
            return this.sipsTable.relativeYearMonthlyNeeds;
        },

        relativeYearBenchmarkStartingBalance() {
            return this.sipsTable.relativeYearBenchmarkStartingBalance;
        },

        relativeYearPortfolioStartingBalance() {
            return this.sipsTable.relativeYearPortfolioStartingBalance;
        },

        sipsTable() {
            return this.sipsTable.sipsTable;
        },

        yearsPeopleDie() {
            return this.sipsTable.yearsPeopleDie;
        },

        showBenchMark() {
            return this.sipsTable.showBenchMark;
        }

    },

    actions: {
        fetchIncomePlanner ({commit}, householdId) {
            return incomePlanAxios
                .get(process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId + '/income-planner')
                .then(r => r.data.data)
                .then(response => {
                    commit('setIncomePlanner', response)
                });
        },

        fetchIncomePlannerVariables({commit}, householdId) {
            incomePlanAxios
                .get(process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId + '/income-planner/variables')
                .then(r => r.data.data)
                .then(response => {
                    commit(INCOME_NEEDS_VARIABLES_INITIALIZED, response.incomeNeeds);
                    commit(INFLATION_RATE_INITIALIZED, response.inflation);
                });
        },

        /**
         * Store an adjustment
         * @param commit
         * @param payload
         * @param householdId
         * @returns {Promise<void>}
         */
        createIncomeNeedsAdjustment ({commit}, {payload, addDefault, householdId}) {
            return incomePlanAxios.post(
                process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId + '/income-planner/variables/income-needs-adjustment',
                    payload
                ).then(
                    response => response.data.data
                ).then(
                    response => {
                        if (response.result) {
                            payload.id = response.result;
                            if (addDefault) {
                                commit(INCOME_NEEDS_ADJUSTMENT_DEFAULT_CREATED, payload);
                            } else {
                                commit(INCOME_NEEDS_ADJUSTMENT_CREATED, payload);
                            }
                        }
                        if (response.incomePlanner) {
                            commit('setIncomePlanner', response.incomePlanner);
                        }
                    }
                );
        },

        /**
         * Update an adjustment
         * @param commit
         * @param payload
         * @param householdId
         * @returns {Promise<void>}
         */
        updateIncomeNeedsAdjustment ({commit}, {payload, householdId}) {
            return incomePlanAxios.put(
                process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId + '/income-planner/variables/income-needs-adjustment',
                    payload
            ).then(
                response => response.data.data
            ).then(
                response => {
                    if (response.result) {
                        commit(INCOME_NEEDS_ADJUSTMENT_UPDATED, payload);
                    }
                    if (response.incomePlanner) {
                        commit('setIncomePlanner', response.incomePlanner);
                    }
                }
            );
        },

        /**
         * Delete an adjustment
         * @param commit
         * @param payload
         * @param householdId
         * @returns {Promise<void>}
         */
        deleteIncomeNeedsAdjustment ({commit}, {payload, householdId}) {
            return incomePlanAxios.delete(
                process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId + '/income-planner/variables/income-needs-adjustment',
                { data: {...payload} }
            ).then(
                response => response.data.data
            ).then(
                response => {
                    if (response.result) {
                        commit(INCOME_NEEDS_ADJUSTMENT_DELETED, payload.id)
                    }
                    if (response.incomePlanner) {
                        commit('setIncomePlanner', response.incomePlanner);
                    }
                }
            )
        },

        /**
         * Update income needs components
         * @param commit
         * @param payload
         * @param householdId
         */
        updateIncomeNeeds({commit}, {payload, householdId}) {
            return incomePlanAxios.put(process.env.VUE_APP_BASE_URL + '/api/households/'+ householdId + '/income-planner/variables/income-needs', payload)
                .then(
                    response => response.data.data
                )
                .then(
                    response => {
                        if (response.result) {
                            commit(INCOME_NEEDS_UPDATED, payload);
                        }
                        if (response.incomePlanner) {
                            commit('setIncomePlanner', response.incomePlanner);
                        }
                    }
                );
        }
    },

    mutations: {

        setIncomePlanner(state, data) {
            state.sipsTable = data.sipsTable;
            state.riskMeter = data.riskMeter;
            state.successMeter = data.successMeter;
            state.yearsPeopleDie = data.yearsPeopleDie;
            state.showBenchMark = data.showBenchMark;
        },

        [INCOME_NEEDS_VARIABLES_INITIALIZED] (state, incomeNeeds) {
            //Income needs
            state.incomeNeeds.monthlyIncomeNeeds = incomeNeeds.monthlyIncomeNeeds;

            //Relative Plan Years
            state.incomeNeeds.relativePlanYears = incomeNeeds.relativePlanYears;

            //Include default adjustments if not set
            let defaultAdjustmentsOptions = [...ADJUSTMENT_DEFAULT];

            incomeNeeds.adjustments.forEach(function (adjustment) {
                if (adjustment.description === 'Education Expense') {
                    defaultAdjustmentsOptions[0] = null;
                }
                else if (adjustment.description === 'Health Insurance') {
                    defaultAdjustmentsOptions[1] = null;
                }
                else if (adjustment.description === 'Travel Budget') {
                    defaultAdjustmentsOptions[2] = null;
                }
            });

            let defaultAdjustmentsToAdd  = defaultAdjustmentsOptions.filter(function (adjustment) {
                return adjustment !== null;
            });

            state.incomeNeeds.adjustments = [...incomeNeeds.adjustments, ...defaultAdjustmentsToAdd];
        },



        /**
         *
         * @param state
         * @param payload
         */
        [INCOME_NEEDS_UPDATED] (state, payload) {
            state.incomeNeeds.monthlyIncomeNeeds = payload.monthlyIncomeNeeds;
        },

        /**
         * @param state
         * @param payload
         */
        [INCOME_NEEDS_ADJUSTMENT_CREATED] (state, payload) {
            state.incomeNeeds.adjustments = [payload, ...state.incomeNeeds.adjustments];
        },

        /**
         * Add a default adjustment
         * @param state
         * @param payload
         */
        [INCOME_NEEDS_ADJUSTMENT_DEFAULT_CREATED] (state, payload) {
            let updatedAdjustmentIndex = state.incomeNeeds.adjustments.findIndex(function (adjustment) {
                return adjustment.description === payload.description;
            });
            state.incomeNeeds.adjustments.splice(updatedAdjustmentIndex, 1, payload);
        },

        /**
         * @param state
         * @param id
         */
        [INCOME_NEEDS_ADJUSTMENT_UPDATED] (state, payload) {
            let updatedAdjustmentIndex = state.incomeNeeds.adjustments.findIndex(function (adjustment) {
                return adjustment.id == payload.id;
            });
            state.incomeNeeds.adjustments.splice(updatedAdjustmentIndex, 1, payload);
        },

        /**
         * @param state
         * @param id
         */
        [INCOME_NEEDS_ADJUSTMENT_DELETED] (state, id) {
            state.incomeNeeds.adjustments = state.incomeNeeds.adjustments.filter(function (adjustment) {
                return adjustment.id != id;
            });
        },

        /**
         * Inflation Rate
         * @param state
         * @param inflation
         */
        [INFLATION_RATE_INITIALIZED] (state, inflation) {
            state.inflation = inflation;
        }

    }
}
